<hpf-module-qcm-response-form
	*ngIf="moduleQCMResponse"
	[moduleQCMResponse]="moduleQCMResponse"
	(create)="onCreate($event)"
></hpf-module-qcm-response-form>
<div *ngIf="!moduleQCMResponse" class="my-5 text-center">
	<nz-spin nzSimple></nz-spin>
</div>
